import { appConfig } from '../config/app'

const dateFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: appConfig.timezone,
  dateStyle: 'short',
})

const dateTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: appConfig.timezone,
  dateStyle: 'short',
  timeStyle: 'short',
})

export function nowInBrasilia(): { date: string; time: string } {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: appConfig.timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date())
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value ?? ''
  return {
    date: `${value('year')}-${value('month')}-${value('day')}`,
    time: `${value('hour')}:${value('minute')}`,
  }
}

export function formatBusinessDate(date: string): string {
  const [year, month, day] = date.split('-').map(Number)
  if (!year || !month || !day) return date
  return dateFormatter.format(new Date(Date.UTC(year, month - 1, day, 15)))
}

export function formatAuditTimestamp(timestamp: string): string {
  return dateTimeFormatter.format(new Date(timestamp))
}

export function formatDueDateTime(date: string, time: string | null): string {
  return `${formatBusinessDate(date)} às ${time?.slice(0, 5) ?? '23:59'}`
}

export function localDateTimeKey(date: string, time: string | null): string {
  return `${date}T${time?.slice(0, 5) ?? '23:59'}`
}
